import { HTMLAttributes } from "react"

export default function MixPanel(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 371.61 88"
    >
      <g>
        <path
          className="st0"
          d="M0,68.26h22.29v-2.37h-1.67c-3.26,0-4.04-0.89-4.04-4.14V32.36c2.27-3.85,5.33-6.32,9.18-6.32
		c4.84,0,7.79,3.55,7.79,10.26v25.45c0,3.26-0.79,4.14-3.95,4.14h-1.78v2.37h21.8V65.9h-1.58c-3.26,0-4.04-0.89-4.04-4.14V35.21
		c0-0.89,0-1.78-0.1-2.66c2.17-3.95,5.43-6.51,9.27-6.51c4.84,0,7.8,3.55,7.8,10.26v25.45c0,3.26-0.79,4.14-3.95,4.14h-1.78v2.37
		h21.8V65.9h-1.48c-3.36,0-4.14-0.89-4.14-4.14V35.21c0-9.96-5.62-15.49-13.81-15.49c-6.11,0-11.44,3.36-14.3,10.06
		c-1.67-6.51-6.61-10.06-13.12-10.06c-5.82,0-10.85,3.15-13.62,9.47v-8.29H0v2.37h1.97c3.36,0,4.14,0.89,4.14,4.14v34.33
		c0,3.26-0.79,4.14-4.14,4.14H0V68.26z M90.17,13.02c3.55,0,6.51-2.96,6.51-6.51c0-3.55-2.96-6.51-6.51-6.51
		c-3.55,0-6.51,2.96-6.51,6.51C83.66,10.06,86.62,13.02,90.17,13.02z M79.12,68.26h21.9v-2.37h-1.48c-3.26,0-4.04-0.89-4.04-4.14
		V20.91H78.92v2.37h1.97c3.36,0,4.14,0.89,4.14,4.14v34.33c0,3.26-0.79,4.14-4.14,4.14h-1.78L79.12,68.26L79.12,68.26z M117,40.45
		h6.31c-1.58-0.99-2.17-2.37-2.96-4.93l-2.37-8.78c-1.08-3.95-1.97-5.82-6.31-5.82h-9.07v2.37h1.29c2.66,0,2.96,0.99,3.75,3.95
		l2.07,7.7C110.79,38.68,112.48,40.45,117,40.45L117,40.45z M131.61,40.45h6.31c4.54,0,6.11-1.78,7.2-5.52l2.07-7.7
		c0.79-2.96,1.18-3.95,3.75-3.95h1.29v-2.37h-8.98c-4.44,0-5.33,1.78-6.32,5.82l-2.37,8.78C133.78,38.17,133.18,39.46,131.61,40.45z
		 M123.32,48.73h8.29v-8.29h-8.29V48.73z M102.6,68.27h9.07c4.34,0,5.23-1.88,6.31-5.82l2.37-8.78c0.79-2.56,1.38-3.95,2.96-4.93
		H117c-4.54,0-6.22,1.78-7.3,5.52l-2.07,7.7c-0.79,2.96-1.08,3.95-3.75,3.95h-1.29L102.6,68.27L102.6,68.27z M143.24,68.27h8.98
		V65.9h-1.29c-2.56,0-2.96-0.99-3.75-3.95l-2.07-7.7c-1.08-3.75-2.66-5.52-7.2-5.52h-6.3c1.58,0.99,2.15,2.27,2.94,4.93l2.37,8.78
		C137.91,66.49,138.8,68.27,143.24,68.27L143.24,68.27z M153.5,88h22.88v-2.37h-2.37c-3.15,0-3.95-0.89-3.95-4.14V62.65
		c2.86,4.24,7.7,6.81,13.42,6.81c10.75,0,19.33-9.47,19.33-25.84c0-14.8-8.09-23.87-18.55-23.87c-6.11,0-11.25,3.55-14.21,9.86
		v-8.68h-16.58v2.37h1.97c3.26,0,4.14,0.89,4.14,4.14v54.05c0,3.26-0.89,4.14-4.14,4.14h-1.97v2.37L153.5,88z M180.54,25.85
		c6.41,0,11.64,6.02,11.64,17.95c0,13.02-4.84,20.13-11.44,20.13c-4.25,0-7.99-2.27-10.66-6.22V33.24
		C172.64,28.41,176.3,25.84,180.54,25.85L180.54,25.85z M218.42,69.26c6.41,0,11.54-3.06,15.39-9.96v1.08
		c0,5.92,3.75,8.48,9.96,8.48c1.88,0,4.25-0.19,5.82-0.69v-2.47c-0.79,0.19-1.38,0.3-1.97,0.3c-2.47,0-3.26-1.48-3.26-3.85V36.9
		c0-11.64-6.51-17.17-17.46-17.17c-7.3,0-14.4,3.36-18.94,6.91l1.58,2.77c4.74-3.26,9.37-5.13,14.4-5.13
		c6.51,0,9.86,3.55,9.86,11.84v2.17l-12.14,4.74c-11.05,4.54-15.1,8.78-15.1,15.19C206.57,64.62,211.11,69.26,218.42,69.26
		L218.42,69.26z M216.94,55.64c0-4.93,2.86-8.48,8.68-11.05l8.19-3.55v15.39c-3.06,4.24-6.61,6.71-10.46,6.71
		C219.51,63.14,216.95,60.48,216.94,55.64L216.94,55.64z M251.56,68.27h22.5V65.9h-1.88c-3.26,0-4.04-0.89-4.04-4.14v-29.3
		c2.27-3.95,5.62-6.41,9.57-6.41c5.13,0,8.39,3.55,8.39,10.26v25.45c0,3.26-0.79,4.14-3.95,4.14h-1.88v2.37h22.39V65.9h-1.97
		c-3.36,0-4.14-0.89-4.14-4.14V35.21c0-9.96-5.92-15.49-14.3-15.49c-6.11,0-11.25,3.15-14.11,9.47v-8.29h-16.58v2.37h1.97
		c3.36,0,4.14,0.89,4.14,4.14v34.33c0,3.26-0.79,4.14-4.14,4.14h-1.97L251.56,68.27L251.56,68.27z M328.31,69.45
		c6.51,0,12.63-2.96,17.07-6.51l-1.48-2.17c-3.95,2.86-8.39,4.14-12.53,4.14c-10.06,0-15.98-7.1-15.98-20.91v-1.78h31.17
		c-0.19-13.32-8.39-22.39-20.32-22.39c-11.93,0-21.51,10.75-21.51,24.96C304.74,60.39,313.62,69.46,328.31,69.45L328.31,69.45z
		 M326.34,22.29c5.92,0,9.57,6.41,10.16,17.26h-20.91C316.48,28.61,320.62,22.29,326.34,22.29L326.34,22.29z M348.73,68.26h22.88
		v-2.37h-2.27c-3.26,0-4.04-0.89-4.04-4.14V1.18h-16.58v2.37h1.97c3.26,0,4.14,0.89,4.14,4.14v54.06c0,3.26-0.89,4.14-4.14,4.14
		h-1.97L348.73,68.26L348.73,68.26z"
        ></path>
      </g>
    </svg>
  )
}
